<div class="nav nav-tabs" role="tablist">
  @for (item of items; track $index) {
    <div class="nav-item">
      <button
        class="nav-link"
        role="tab"
        [disabled]="item.disabled"
        [ngClass]="{ active: $index === activeIndex }"
        [attr.aria-selected]="$index === activeIndex"
        (click)="onClick($event, $index)"
        (keydown)="onKeyDown($event, $index)"
        [tabindex]="$index === activeIndex && !item.disabled ? 0 : -1"
      >
        <ng-container *ngTemplateOutlet="item.template"></ng-container>
      </button>
    </div>
  }
</div>
